import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouterLegacy } from 'core/routerUtils';
import { withTranslation } from 'react-i18next';
import { addLeadingZeros } from 'shared/helpers';
import { Select, SimpleModal } from 'shared/components';
import { SeatingChartGrid, SeatingChartSelectionBar } from 'features/seating-chart';
import * as seatingChartActions from 'features/seating-chart/duck';
import {
  cloneDeep,
  concat,
  difference,
  filter,
  find,
  flatMap,
  isEmpty,
  sortedUniq,
  sortBy,
} from 'lodash';

import './SeatingChartAssign.scss';

const rangeArr = (start, stop, step = 1) =>
  Array(stop - start + 1)
    .fill(start)
    .map((x, y) => addLeadingZeros(+x + y * step, start.length));

const generateBookletsArray = (ranges) => {
  let data = [];
  ranges.map((range) => {
    data = concat(data, rangeArr(range.rangeBegin, range.rangeEnd));
  });

  return sortedUniq(sortBy(data));
};

const generateRegMaterials = (seatsData, materialTypeId) => {
  let data = [];
  let emptyCell = {};
  let seats = cloneDeep(seatsData);
  seats.map(
    (seatsRow) =>
      seatsRow &&
      seatsRow.map((seat) => {
        if (seat) {
          if (isEmpty(data[seat.seatRow])) {
            data[seat.seatRow] = [];
          }
          emptyCell = {
            regId: seat.id,
            materialTypeId: materialTypeId,
            serialNumber: '',
          };

          seat.regMaterials = find(seat.regMaterials, {
            materialTypeId: materialTypeId,
          });

          data[seat.seatRow][seat.seatCol] = !isEmpty(seat.regMaterials)
            ? seat.regMaterials
            : emptyCell;
        }
      })
  );
  return data;
};

const getNextBooklet = (booklets, currentBooklet, selectedBooklet) => {
  if (!booklets.length) {
    return '';
  }

  if (selectedBooklet !== undefined && currentBooklet != selectedBooklet) {
    return currentBooklet;
  }

  const index = booklets.indexOf(currentBooklet);
  return booklets[index + 1] !== undefined
    ? booklets[index + 1]
    : booklets.length === 1
      ? ''
      : booklets[0];
};

class SeatingChartAssign extends Component {
  constructor(props) {
    super(props);

    this.state = {
      discardModalOpen: false,
      clearAllModalOpen: false,
      isDirty: false,
      seatsData: [],
      booklets: [],
      allBooklets: [],
      selectedBooklet: '',
      materialType: {
        name: '',
      },
    };

    this.handleSelectSeat = this.handleSelectSeat.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
    this.closeDiscardModal = this.closeDiscardModal.bind(this);
    this.toggleClearAllModal = this.toggleClearAllModal.bind(this);
    this.seatingChart = React.createRef();
  }

  componentDidMount() {
    const { match, roomsRanges, roomTypeMaterialTypes } = this.props;

    const materialTypeId = +match.params.materialId;
    const materialType = find(roomTypeMaterialTypes, { id: materialTypeId });
    const allBooklets = generateBookletsArray(
      filter(roomsRanges, { materialTypeId: materialTypeId })
    );
    const seatsData = generateRegMaterials(this.props.seatsData, materialTypeId);
    const booklets = difference(
      allBooklets,
      flatMap(
        seatsData.flat().filter((n) => n),
        (n) => n && n.serialNumber
      )
    );

    this.setState((prevState) => ({
      materialType: isEmpty(materialType) ? prevState.materialType : materialType,
      booklets: booklets,
      seatsData: seatsData,
      selectedBooklet: booklets.length ? booklets[0] : '',
      allBooklets,
    }));

    if (!booklets.length) {
      $('.select-booklets')
        .attr('data-bs-toggle', 'tooltip')
        .attr('data-bs-html', 'true')
        .attr('data-bs-placement', 'bottom')
        .attr('data-bs-title', this.props.t('seatingChart.assign.noMaterialsTooltip'));
      $('.empty-seat')
        .attr('data-bs-toggle', 'tooltip')
        .attr('data-bs-html', 'true')
        .attr('data-bs-boundary', 'window')
        .attr('data-bs-placement', 'auto')
        .attr('data-bs-title', this.props.t('seatingChart.assign.noMaterialsTooltip'));
      Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach((el) =>
        bootstrap.Tooltip.getOrCreateInstance(el).enable()
      );
    } else {
      // $('.select-booklets').removeAttr('data-bs-toggle').removeAttr('title').removeAttr('data-original-title');
      Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach((el) =>
        bootstrap.Tooltip.getOrCreateInstance(el).disable()
      );
    }
  }

  componentDidUpdate() {
    const { booklets } = this.state;

    if (!booklets.length) {
      $('.select-booklets')
        .attr('data-bs-toggle', 'tooltip')
        .attr('data-bs-html', 'true')
        .attr('data-bs-placement', 'bottom')
        .attr('data-bs-title', this.props.t('seatingChart.assign.noMaterialsTooltip'));
      $('.empty-seat')
        .attr('data-bs-toggle', 'tooltip')
        .attr('data-bs-html', 'true')
        .attr('data-bs-placement', 'auto')
        .attr('data-bs-title', this.props.t('seatingChart.assign.noMaterialsTooltip'));
      Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach((el) =>
        bootstrap.Tooltip.getOrCreateInstance(el).enable()
      );
    } else {
      Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach((el) =>
        bootstrap.Tooltip.getOrCreateInstance(el).disable()
      );
      $('.select-booklets')
        .removeAttr('data-bs-toggle')
        .removeAttr('data-bs-title')
        .removeAttr('data-bs-html');
      $('.empty-seat')
        .removeAttr('data-bs-toggle')
        .removeAttr('data-bs-title')
        .removeAttr('data-bs-html');
    }
  }

  handleSelectSeat(i, j, serialNumber) {
    let seats = cloneDeep(this.state.seatsData);
    let booklets = cloneDeep(this.state.booklets);
    let selectedBooklet = this.state.selectedBooklet;

    if (seats[i][j]) {
      if (!seats[i][j].serialNumber) {
        if (!isEmpty(booklets)) {
          seats[i][j].serialNumber = this.state.selectedBooklet;
          booklets = sortedUniq(booklets);
          selectedBooklet = getNextBooklet(booklets, selectedBooklet);
          booklets = filter(booklets, (n) => n != this.state.selectedBooklet);
        }
        this.setState({
          seatsData: seats,
          booklets: booklets,
          selectedBooklet: selectedBooklet,
          isDirty: true,
        });
      } else {
        //add the unassigned serialNumber back into the booklets array
        booklets.push(seats[i][j].serialNumber);
        booklets = sortedUniq(sortBy(booklets));
        selectedBooklet =
          booklets.length === this.state.allBooklets.length
            ? booklets[0]
            : seats[i][j].serialNumber;

        seats[i][j].serialNumber = serialNumber;

        if (serialNumber) {
          booklets = filter(booklets, (n) => n != serialNumber);
        }
        this.setState({
          seatsData: seats,
          booklets: booklets,
          selectedBooklet: selectedBooklet,
          isDirty: true,
        });
      }
    }
  }

  handleClearAll() {
    const { match, roomsRanges } = this.props;

    const materialTypeId = +match.params.materialId;
    let seats = cloneDeep(this.state.seatsData);

    seats.map(
      (seatsRow) =>
        seatsRow &&
        seatsRow.map((seat) => {
          if (!isEmpty(seat)) {
            seat.serialNumber = '';
          }
        })
    );

    const booklets = generateBookletsArray(filter(roomsRanges, { materialTypeId: materialTypeId }));

    this.setState({
      seatsData: seats,
      booklets: booklets,
      selectedBooklet: booklets.length ? booklets[0] : '',
      isDirty: true,
    });
  }

  handleChange(e) {
    this.setState({
      selectedBooklet: e.target.value,
    });
  }

  async handleSave() {
    const { actions, match, room } = this.props;

    const { materialType, seatsData } = this.state;

    await actions.assignMaterialsToRegs(room.id, {
      materialTypeId: +match.params.materialId,
      regMaterials: filter(
        seatsData.flat().filter((n) => n),
        (n) => n && n.serialNumber
      ),
    });
    await actions.getRegSummaries(room.id);

    sessionStorage.setItem(
      'successSavedMessage',
      this.props.t('seatingChart.assign.successMessage', {
        materialName: materialType.name,
      })
    );
    this.props.history.goBack();
  }

  handleBack() {
    if (this.state.isDirty) {
      this.setState({
        discardModalOpen: true,
      });
    } else {
      this.props.history.goBack();
    }
  }

  closeDiscardModal(goBack) {
    if (goBack) {
      this.props.history.goBack();
    }
    this.setState({
      discardModalOpen: false,
    });
  }

  toggleClearAllModal(clear) {
    if (clear) {
      this.handleClearAll();
    }
    this.setState((prevState) => ({
      clearAllModalOpen: !prevState.clearAllModalOpen,
    }));
  }

  render() {
    const { room } = this.props;

    const {
      booklets,
      discardModalOpen,
      clearAllModalOpen,
      materialType,
      seatsData,
      selectedBooklet,
    } = this.state;

    let assignedSeats = 0;
    seatsData?.map((seatsRow) =>
      seatsRow?.map((seat) => {
        if (seat && seat.serialNumber) {
          assignedSeats++;
        }
      })
    );

    return (
      <div className="seating-chart-assign-seats">
        <div className="container title-container mb-30">
          <h4 className="pt-3">
            {this.props.t('seatingChart.assign.title', {
              materialName: materialType.name,
            })}
          </h4>
          <p className="text-strong">{this.props.t('seatingChart.assign.subtitle')}</p>
        </div>

        <div className="bg-white-smoke">
          <div className="select-bar">
            <div className="container">
              <div className="assign-booklets">
                <div>
                  {this.props.t('seatingChart.assign.nextBookletLabel', {
                    materialName: materialType.name,
                  })}
                  <span>{this.props.t('seatingChart.assign.nextBookletLabel2')}</span>
                </div>

                <div className="select-booklets">
                  <Select
                    options={booklets.map((x) => ({ value: x, label: x }))}
                    value={selectedBooklet}
                    name="booklets"
                    placeholder={this.props.t('seatingChart.assign.noMaterialsLabel')}
                    disabled={!booklets.length}
                    onChange={this.handleChange}
                  />
                </div>
              </div>

              <div>
                <button
                  className="btn-link"
                  disabled={!assignedSeats}
                  onClick={() => this.toggleClearAllModal(false)}>
                  {this.props.t('common.labels.clearAll')}
                </button>
              </div>
            </div>
          </div>

          <div className="container" ref={this.seatingChart}>
            <SeatingChartGrid
              rows={room.seatingRowCount}
              cols={room.seatingColumnCount}
              seatsData={seatsData}
              type="assign"
              handleSeatClick={this.handleSelectSeat}
              availableBooklets={booklets}
              seatingChart={this.seatingChart}
            />
          </div>
        </div>

        <SeatingChartSelectionBar
          count={assignedSeats}
          total={booklets.length + assignedSeats}
          selectedSeatsLabel="seatingChart.usedOf"
          handleSave={this.handleSave}
          handleBack={this.handleBack}
        />

        <SimpleModal
          isOpen={discardModalOpen}
          onCancel={() => this.closeDiscardModal(false)}
          onConfirm={() => this.closeDiscardModal(true)}
          confirmLabel={this.props.t('common.labels.yes')}
          cancelLabel={this.props.t('common.labels.no')}
          headline={this.props.t('common.backModal.title')}
          message={this.props.t('common.backModal.discardPageMessage')}
          buttonsReverseOrder
        />

        <SimpleModal
          isOpen={clearAllModalOpen}
          onCancel={() => this.toggleClearAllModal(false)}
          onConfirm={() => this.toggleClearAllModal(true)}
          confirmLabel={this.props.t('common.labels.clearAll')}
          cancelLabel={this.props.t('common.labels.no')}
          headline={this.props.t('seatingChart.clearAllModalTitle')}
          message={this.props.t('seatingChart.clearAllModalMessage')}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    room: state.roomOptions.room || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...seatingChartActions,
      },
      dispatch
    ),
  };
}

export default withTranslation()(
  withRouterLegacy(connect(mapStateToProps, mapDispatchToProps)(SeatingChartAssign))
);

SeatingChartAssign.propTypes = {
  t: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({}),
  }),
  roomsRanges: PropTypes.arrayOf(PropTypes.shape({})),
  roomTypeMaterialTypes: PropTypes.arrayOf(PropTypes.shape({})),
  seatsData: PropTypes.array,
  room: PropTypes.shape({}),
  actions: PropTypes.shape({}),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
